<template>
  <div class="about-banner">
    <img :src="mobileaboutBanner" alt="" />
    <div class="absolute">
      <div class="title">关于畅月</div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobileaboutBanner from "../../../assets/about/mobileaboutBanner.png";

export default {
  setup() {
    return reactive({
      mobileaboutBanner: mobileaboutBanner,
    });
  },
};
</script>

<style scoped>
.about-banner {
  position: relative;
}
.about-banner img {
  width: 100%;
  height: 160px;
}
.absolute {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.absolute .title {
  font-size: 18px;
  color: #fff;
}
.absolute .text {
  width: 92vw;
  font-size: 16px;
  color: #fff;
  margin: 10px auto 0;
}
</style>
